module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M14 11.64V23c0 .558.44 1 1 1h2c.56 0 1-.442 1-1V11.64c2.32-.84 4-3.04 4-5.64 0-3.32-2.68-6-6-6s-6 2.68-6 6c0 2.6 1.68 4.8 4 5.64zM30 6h-4c0 1.42-.3 2.782-.82 4H28v18H4V10h2.82C6.3 8.782 6 7.42 6 6H2C.9 6 0 6.9 0 8v22c0 1.1.9 2 2 2h28c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/location-pin-5.js
// module id = 1242
// module chunks = 14